import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from "react-redux";

import configureStore from "./store";

import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/bootstrap-compat.scss';

const store = configureStore();

ReactDOM.render(
  <ReduxProvider store={store}>
    <App />
  </ReduxProvider>,
  document.getElementById('root')
);
